const authErrorCodes = {
  // User-related errors
  USER_NOT_FOUND: "user_not_found",
  USER_ALREADY_EXISTS: "user_already_exists",
  USER_BANNED: "user_banned",
  USER_SSO_MANAGED: "user_sso_managed",

  // Email-related errors
  INVALID_EMAIL: "invalid_email",
  EMAIL_EXISTS: "email_exists",
  EMAIL_NOT_CONFIRMED: "email_not_confirmed",
  EMAIL_PROVIDER_DISABLED: "email_provider_disabled",
  EMAIL_ADDRESS_INVALID: "email_address_invalid",
  EMAIL_ADDRESS_NOT_AUTHORIZED: "email_address_not_authorized",
  EMAIL_ALREADY_IN_USE: "email_already_in_use",
  EMAIL_CONFLICT_IDENTITY_NOT_DELETABLE: "email_conflict_identity_not_deletable",

  // Credentials errors
  INVALID_CREDENTIALS: "invalid_credentials",
  PASSWORD_REQUIRED: "password_required",
  WEAK_PASSWORD: "weak_password",
  SAME_PASSWORD: "same_password",
  REAUTHENTICATION_NEEDED: "reauthentication_needed",
  REAUTHENTICATION_NOT_VALID: "reauthentication_not_valid",

  // Authentication method errors
  SIGNUP_DISABLED: "signup_disabled",
  ANONYMOUS_PROVIDER_DISABLED: "anonymous_provider_disabled",
  PHONE_PROVIDER_DISABLED: "phone_provider_disabled",
  PROVIDER_DISABLED: "provider_disabled",
  PROVIDER_EMAIL_NEEDS_VERIFICATION: "provider_email_needs_verification",

  // JWT/Session errors
  BAD_JWT: "bad_jwt",
  BAD_CODE_VERIFIER: "bad_code_verifier",
  SESSION_EXPIRED: "session_expired",
  SESSION_NOT_FOUND: "session_not_found",
  REFRESH_TOKEN_NOT_FOUND: "refresh_token_not_found",
  REFRESH_TOKEN_ALREADY_USED: "refresh_token_already_used",

  // OAuth errors
  BAD_OAUTH_CALLBACK: "bad_oauth_callback",
  BAD_OAUTH_STATE: "bad_oauth_state",
  OAUTH_PROVIDER_NOT_SUPPORTED: "oauth_provider_not_supported",

  // Flow state errors
  FLOW_STATE_EXPIRED: "flow_state_expired",
  FLOW_STATE_NOT_FOUND: "flow_state_not_found",

  // Rate limiting and security
  OVER_REQUEST_RATE_LIMIT: "over_request_rate_limit",
  OVER_EMAIL_SEND_RATE_LIMIT: "over_email_send_rate_limit",
  OVER_SMS_SEND_RATE_LIMIT: "over_sms_send_rate_limit",
  CAPTCHA_FAILED: "captcha_failed",

  // OTP errors
  OTP_DISABLED: "otp_disabled",
  OTP_EXPIRED: "otp_expired",

  // Phone-related errors
  PHONE_EXISTS: "phone_exists",
  PHONE_NOT_CONFIRMED: "phone_not_confirmed",
  SMS_SEND_FAILED: "sms_send_failed",

  // MFA errors
  MFA_CHALLENGE_EXPIRED: "mfa_challenge_expired",
  MFA_FACTOR_NAME_CONFLICT: "mfa_factor_name_conflict",
  MFA_FACTOR_NOT_FOUND: "mfa_factor_not_found",
  MFA_IP_ADDRESS_MISMATCH: "mfa_ip_address_mismatch",
  MFA_PHONE_ENROLL_NOT_ENABLED: "mfa_phone_enroll_not_enabled",
  MFA_PHONE_VERIFY_NOT_ENABLED: "mfa_phone_verify_not_enabled",
  MFA_TOTP_ENROLL_NOT_ENABLED: "mfa_totp_enroll_not_enabled",
  MFA_WEBAUTHN_ENROLL_NOT_ENABLED: "mfa_webauthn_enroll_not_enabled",
  MFA_WEBAUTHN_VERIFY_NOT_ENABLED: "mfa_webauthn_verify_not_enabled",
  TOO_MANY_ENROLLED_MFA_FACTORS: "too_many_enrolled_mfa_factors",
  INSUFFICIENT_AAL: "insufficient_aal",

  // Identity errors
  IDENTITY_ALREADY_EXISTS: "identity_already_exists",
  IDENTITY_NOT_FOUND: "identity_not_found",
  SINGLE_IDENTITY_NOT_DELETABLE: "single_identity_not_deletable",
  MANUAL_LINKING_DISABLED: "manual_linking_disabled",

  // SAML errors
  SAML_ASSERTION_NO_EMAIL: "saml_assertion_no_email",
  SAML_ASSERTION_NO_USER_ID: "saml_assertion_no_user_id",
  SAML_ENTITY_ID_MISMATCH: "saml_entity_id_mismatch",
  SAML_IDP_ALREADY_EXISTS: "saml_idp_already_exists",
  SAML_IDP_NOT_FOUND: "saml_idp_not_found",
  SAML_METADATA_FETCH_FAILED: "saml_metadata_fetch_failed",
  SAML_PROVIDER_DISABLED: "saml_provider_disabled",
  SAML_RELAY_STATE_EXPIRED: "saml_relay_state_expired",
  SAML_RELAY_STATE_NOT_FOUND: "saml_relay_state_not_found",

  // SSO errors
  SSO_DOMAIN_ALREADY_EXISTS: "sso_domain_already_exists",
  SSO_PROVIDER_NOT_FOUND: "sso_provider_not_found",

  // Invite errors
  INVITE_NOT_FOUND: "invite_not_found",

  // Hook errors
  HOOK_PAYLOAD_INVALID_CONTENT_TYPE: "hook_payload_invalid_content_type",
  HOOK_PAYLOAD_OVER_SIZE_LIMIT: "hook_payload_over_size_limit",
  HOOK_TIMEOUT: "hook_timeout",
  HOOK_TIMEOUT_AFTER_RETRY: "hook_timeout_after_retry",

  // General errors
  BAD_JSON: "bad_json",
  CONFLICT: "conflict",
  NO_AUTHORIZATION: "no_authorization",
  NOT_ADMIN: "not_admin",
  REQUEST_TIMEOUT: "request_timeout",
  UNEXPECTED_AUDIENCE: "unexpected_audience",
  UNEXPECTED_FAILURE: "unexpected_failure",
  VALIDATION_FAILED: "validation_failed",
} as const;

export { authErrorCodes };
